import React from 'react'
import grid from './grid.module.css'

export default ({ className, ...props}) => 
<div className={[grid['container-fluid'], className].join(' ')} {...props}>
   {props.children}
</div>


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Grid/FluidContainer.js